import { createAction, props } from '@ngrx/store';
import { ICatalogStore } from './catalogStore.reducer';

export const setCatalogStore = createAction('[Catalog] Set Catalog Store', props<ICatalogStore>());
export const clearCatalogStore = createAction('[Catalog] Clear Catalog Store');
